import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { Role } from 'src/app/models/enums/Role.enum';
import { Settings } from 'src/app/models/types/Configuration/Settings.type';
import { UserConfiguration } from 'src/app/models/types/Configuration/UserConfiguration.type';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  private readonly apiUrl = `${environment.apiUrl}/AppConfigurations`;

  constructor(private http: HttpClient) { }

  /**
   * API per il reperimento della configurazione dell'utente.
   * GET /api/AppConfigurations/AppDesktop
   *
   * @returns
   */
  getRole(): Observable<UserConfiguration> {
    const url = `${this.apiUrl}/AppDesktop`;
    return (this.http.get(url) as Observable<UserConfiguration>);
  }

  /**
   * Ritorna il ruolo dell'utente in base alla UserConfiguration fornita come parametro.
   *
   * @param userConfiguration - Configurazione dell'utente
   * @returns
   */
  parseRole(userConfiguration: UserConfiguration): Role {
    const { isUserHQ, isUserGlobalHQ, isUserNoStore, isUserBp } = userConfiguration;
    switch (true) {
      case isUserGlobalHQ: return Role.GlobalHQ;
      case isUserNoStore: return Role.NoStore;
      case isUserHQ: return Role.HQ;
      case isUserBp: return Role.Bp;
      default: return Role.Store;
    }
  }

  /**
   * API per il reperimento delle companies all'interno delle settings.
   * Da fare solo se l'utente non è di tipo STORE
   * GET /api/AppConfigurations/Settings
   *
   * @returns
   */
  getSettings(): Observable<Settings> {
    const url = `${this.apiUrl}/Settings`;
    return (this.http.get(url) as Observable<Settings>);
  }

}
